/* eslint-disable no-unsafe-optional-chaining */
import { container } from '@_plugins/ioc';
import LaravelAPI from '@data/api/laravel.api';
import { toCustomer } from '@data/dto/customer.dto';
import { Meta, PaginateResult } from '@data/models/api.interface';
import { Customer, CustomerHttp } from '@data/models/customer.interface';
import { FilterParams } from '@data/models/filter.interface';
import ErrorService from 'core/error.service';
import { injectable } from 'inversify';

@injectable()
export default class CustomerService {
  private API = container.get<LaravelAPI>(LaravelAPI);
  private readonly customerEndpoint = '/clients';
  private errorService = container.get<ErrorService>(ErrorService);

  public async listCustomers(
    filters: FilterParams,
  ): Promise<PaginateResult<Customer[]>> {
    const { data: response, error } = await this.API?.get<{
      data: CustomerHttp[];
      meta: Meta;
    }>(this.customerEndpoint, filters);

    if (error) {
      this.errorService.handleHttpError(error);
      return {
        items: [],
        totalSize: 0,
      };
    }

    return {
      items: response?.data?.map(toCustomer) || [],
      totalSize: response?.meta?.page?.total || 0,
    };
  }
}
